export default __webpack_public_path__ + "media/zurb/img/home/home-service-img2-dcc341a6665cb18c9502b87495872fd3.png";